/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import PropTypes from 'prop-types';

import iconFacebook from '../../assets/images/icon_facebook.png';
import iconInstagram from '../../assets/images/icon_instagram.png';
import iconChat from '../../assets/images/icon_chat.png';
import bgPadocaria from '../../assets/images/bg_padocaria.png';

import { getImagem } from '../../utils/imagens';
import { isPreConcurso } from '../../utils/fase';

import Patrocinadores from './Patrocinadores';
import ContadorRegressivo from './ContadorRegressivo';

import '../../assets/scss/components/Hero.scss';

const Hero = ({ cidade, mostrarBotaoVotar, onVoteClick }) => {
  const {
    hero,
    titulo,
    tituloDestaque,
    subtitulo,
    redesSociais,
    patrocinadores
  } = cidade;

  const logoSrc = getImagem(hero.logo);
  const preConcurso = isPreConcurso(cidade);

  return (
    <section className="in-init">
      <div className="in-init-bg">
        <img src={bgPadocaria} alt="Background Padocaria" />
      </div>
      <div className="in-init-line">
        <hr />
      </div>
      <div className="in-init-socials">
        <div className="in-init-socials-center">
          {redesSociais.facebook && (
            <a href={redesSociais.facebook} rel="noreferrer" target="_blank">
              <img src={iconFacebook} alt="Facebook" />
            </a>
          )}
          {redesSociais.instagram && (
            <a href={redesSociais.instagram} rel="noreferrer" target="_blank">
              <img src={iconInstagram} alt="Instagram" />
            </a>
          )}
        </div>
      </div>
      <div className="in-init-ctn">
        <div className="in-init-ctn-grid">
          <div className="in-init-ctn-grid-logo">
            <img src={logoSrc} alt={hero.logoAlt} />
          </div>
          <div className="in-init-ctn-grid-info">
            <div className="in-init-ctn-grid-info-icon">
              <img src={iconChat} alt="Ícone" />
            </div>
            <div className="in-init-ctn-grid-info-title">
              <p>{titulo}</p>
              <h1
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: `${tituloDestaque.replace(
                    /de\s/i,
                    'de<br /><span> '
                  )}</span>`
                }}
              />
            </div>
            <div className="in-init-ctn-grid-info-subtitle">
              <p>
                {subtitulo.split('\n').map((linha, i) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <React.Fragment key={i}>
                    {linha}
                    {i < subtitulo.split('\n').length - 1 && <br />}
                  </React.Fragment>
                ))}
              </p>
            </div>
            {preConcurso && (
              <div className="hero__contador-wrapper">
                <ContadorRegressivo cidade={cidade} />
              </div>
            )}
            {mostrarBotaoVotar && (
              <div className="in-init-ctn-grid-info-votenow">
                <span
                  onClick={onVoteClick}
                  role="button"
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') onVoteClick();
                  }}
                >
                  Vote agora!
                </span>
              </div>
            )}
          </div>
          {!preConcurso && patrocinadores && (
            <Patrocinadores
              patrocinadores={patrocinadores}
              className={cidade ? `regua-patrocinio--${cidade.slug}` : ''}
            />
          )}
        </div>
      </div>
    </section>
  );
};

Hero.propTypes = {
  cidade: PropTypes.shape({
    slug: PropTypes.string,
    hero: PropTypes.shape({
      logo: PropTypes.string.isRequired,
      logoAlt: PropTypes.string.isRequired,
      bgImagem: PropTypes.string,
      iconeTitulo: PropTypes.string
    }).isRequired,
    titulo: PropTypes.string.isRequired,
    tituloDestaque: PropTypes.string.isRequired,
    subtitulo: PropTypes.string.isRequired,
    redesSociais: PropTypes.shape({
      facebook: PropTypes.string,
      instagram: PropTypes.string
    }).isRequired,
    patrocinadores: PropTypes.shape({
      titulo: PropTypes.string,
      grupos: PropTypes.arrayOf(
        PropTypes.shape({
          tipo: PropTypes.string,
          label: PropTypes.string,
          logos: PropTypes.arrayOf(
            PropTypes.shape({
              href: PropTypes.string,
              imagem: PropTypes.string,
              alt: PropTypes.string,
              width: PropTypes.number
            })
          )
        })
      ),
      linhas: PropTypes.arrayOf(
        PropTypes.arrayOf(
          PropTypes.shape({
            tipo: PropTypes.string,
            label: PropTypes.string,
            logos: PropTypes.arrayOf(
              PropTypes.shape({
                href: PropTypes.string,
                imagem: PropTypes.string,
                alt: PropTypes.string,
                width: PropTypes.number
              })
            )
          })
        )
      )
    })
  }).isRequired,
  mostrarBotaoVotar: PropTypes.bool,
  onVoteClick: PropTypes.func
};

Hero.defaultProps = {
  mostrarBotaoVotar: false,
  onVoteClick: () => {}
};

export default Hero;
